import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateQuotationSchema } from "@/v2/schema/quotation";
import { Quotation } from "@/v2/types";

export default async function CreateQuotation(
    data: CreateQuotationSchema,
): Promise<Quotation> {
    const res = await apiClientWithRefreshToken({
        url: "/quotations",
        method: "POST",
        data: data,
    });

    return res.data;
}
